import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';
import { PessoaDTO } from '../../../../../../models/clientes/pessoa.model';
import { PessoaService } from '../../../../../../services/pessoas/pessoas.service';
import { ItemDTO } from '../../../../../../models/item.model';

@Component({
  selector: 'app-item-form-card',
  templateUrl: './item-form-card.component.html',
  styleUrls: ['./item-form-card.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class ItemFormCardComponent implements OnInit, OnDestroy {
  @Input() pessoaId: number | undefined;
  pessoa: PessoaDTO = {} as PessoaDTO;
  pessoaValores: any;
  @Input() itemSelected: ItemDTO = {} as ItemDTO;

  // Objetos de traducao
  texts = {
    titulo: ''
  };

  private langChangeSub!: Subscription;

  constructor(
    private pessoaService: PessoaService,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.loadTranslations();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });

    if (this.pessoaId === undefined) return;
    await this.findPessoaValores();
  }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  private loadTranslations(): void {
    this.texts = {
      titulo: this.translate.instant('shared.pessoas-card.titulo')
    };
  }

  findPessoaValores(): Promise<void> {
    return new Promise((resolve) => {
      this.pessoaService
        .getPessoasValores(
          `/pessoas/listarValoresTotaisPessoa?pessoaId=${this.pessoaId}`
        )
        .subscribe((response) => {
          this.pessoaValores = response[0];
          this.pessoa = response[0].pessoaDTO;
          resolve();
        });
    });
  }

  get itemName() {
    return this.itemSelected.nome
      ? '( ' + this.itemSelected.id + ' )' + this.itemSelected.nome
      : 'Selecione um Item';
  }
}
